import React, { useEffect, useState } from "react";
import Circle from "../../../../Assets/Images/sm-Circle.svg";
import BookmarkPlus from "../../../../Assets/Images/bookmark-plus.svg";
import BookmarkedIcon from "../../../../Assets/Images/Bookmarked-item.svg";
import Header from "../ShareElements/ContentHeader/ContentHeader";
import ImagePreloader from "../ShareElements/ImagePreloader/ImagePreloader";
import Head from "./Components/Head";
import "../../../../Assets/Styles/JPAdetails.scss";
import CandidateItem from "./Components/CandidateItem";
import { Config } from "../../../../Config";
import axios from "axios";
import EmptyState from "../ShareElements/EmptyState/FormEmptyState";
import { NavLink } from "react-router-dom";
import CandidateSkeleton from "./Components/CandidateItemLoadingSkeleton";
import Select from "../../../Dashboard/Components/ShareElements/Select/Select";

const JobDetails = (props) => {
  const [ItemDetails, setItemDetails] = useState();
  const [Candidates, setCandidates] = useState([]);
  const [DeletedCandidates, setDeletedCandidates] = useState([]); //known as archived candidates on the Back-end
  const [Locations, setLocations] = useState([]);
  const [IsAccepted, setIsAccepted] = useState(false);
  const [Statuses, setStatuses] = useState([
    { name: "Accepted", id: "ACCEPTED" },
    { name: "Not Accepted", id: "NOT_ACCEPTED" },
    { name: "Applied", id: "APPLIED" },
    { name: "Review", id: "REVIEW" },
    { name: "Interview", id: "INTERVIEW" },
    { name: "Decision", id: "FINAL_DECISION" },
    { name: "Cancelled", id: "CANCELLED" },
  ]);
  const [IdentityFilterOptions] = useState([
    { name: "With Identity", id: "DEFAULT" },
    { name: "Without Identity", id: "ANONYMOUS" },
  ]);
  const [NoCandidates, setNoCandidates] = useState(false);
  const [IsLoading, setIsLoading] = useState(true);
  const [SizeOptions] = useState([
    { name: 6, id: 6 },
    { name: 9, id: 9 },
    { name: 12, id: 12 },
  ]);
  const [Pages, setPages] = useState([]);
  const [SelectedSize, setSelectedSize] = useState(6);
  const [PageInfo, setPageInfo] = useState({});
  const [TotalElements, setTotalElements] = useState();

  useEffect(() => {
    fetchJPADetails();
    return () => {
      window.localStorage.removeItem("JPAItemId");
      window.localStorage.removeItem("notif_candidate_name");
    };
  }, []);

  const fetchJPADetails = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/recruitment/detail/" +
        window.localStorage.getItem("JPAItemId"),
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setItemDetails(Res.data);
        window.scrollTo(0, 0);
        if (window.localStorage.getItem("notif_candidate_name") !== null) {
          fetchCandidates(
            true,
            0,
            6,
            window.localStorage.getItem("notif_candidate_name")
          );
        } else {
          fetchCandidates(true, 0, 6);
        }
        checkDeletedCandidatesLength();
        fetchLocationsByJPAId();
        let JPAtoView = Res.data;
        if (JPAtoView.position.recruitmentStatus === "ACCEPTED") {
          setIsAccepted(true);
        } else {
          setIsAccepted(false);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const checkAcceptanceStatus = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/recruitment/detail/" +
        window.localStorage.getItem("JPAItemId"),
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        if (Res.data.position.recruitmentStatus === "ACCEPTED") {
          setIsAccepted(true);
        } else {
          setIsAccepted(false);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const checkDeletedCandidatesLength = () => {
    let JPAId = window.localStorage.getItem("JPAItemId");

    let Data = {
      criteria: {},
      start: 0,
      size: 6,
    };
    let RequestURL =
      window._env_.API_URL +
      Config.PositionServiceURL +
      "/api/position/recruitment/archive-candidates-by-position/" +
      JPAId +
      "/search/candidates";
    let Req = {
      method: "POST",
      baseURL: RequestURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setDeletedCandidates(Res.data.results);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchDeletedCandidates = (IsInitialLoad, Start, Size) => {
    let JPAId = window.localStorage.getItem("JPAItemId");

    let Data = {
      criteria: {},
      start: Start,
      size: Size,
    };

    //nameLike filter
    if (document.getElementById("search-input").value.length > 0) {
      Data.criteria.nameLike = document.getElementById("search-input").value;
    }

    //status filter
    let SelectedStatuses = [];
    Statuses.map((Status) => {
      if (
        document
          .getElementById("icon-" + Status.id)
          .classList.contains("feather-check-selected")
      ) {
        SelectedStatuses.push(Status.id);
      }
    });
    if (SelectedStatuses.length > 0) {
      Data.criteria.applicationStatus = SelectedStatuses;
    }

    //location filter
    let SelectedLocations = [];
    Locations.map((Item) => {
      if (
        document
          .getElementById("icon-" + Item.id)
          .classList.contains("feather-check-selected")
      ) {
        SelectedLocations.push(Item.name);
      }
    });
    if (SelectedLocations.length > 0) {
      Data.criteria.workCities = SelectedLocations;
    }

    //identity filter
    let SelectedIdentities = [];
    IdentityFilterOptions.map((Item) => {
      if (
        document
          .getElementById("icon-" + Item.id)
          .classList.contains("feather-check-selected")
      ) {
        if (Item.id === "ANONYMOUS") {
          SelectedIdentities.push(false);
        } else {
          SelectedIdentities.push(true);
        }
      }
    });
    if (SelectedIdentities.length > 0) {
      Data.criteria.applicationType = SelectedIdentities;
    }

    var RequestURL;
    if (IsInitialLoad) {
      RequestURL =
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/recruitment/archive-candidates-by-position/" +
        JPAId +
        "/search/candidates";
    } else {
      // defining request url based on either saved items are requested or all items (saved items only switch button)
      setTimeout(() => {
        if (
          document.getElementById("saved-switch-holder").classList.length === 1
        ) {
          RequestURL =
            window._env_.API_URL +
            Config.PositionServiceURL +
            "/api/position/recruitment/archive-candidates-by-position/" +
            JPAId +
            "/search/bookmark";
        } else {
          RequestURL =
            window._env_.API_URL +
            Config.PositionServiceURL +
            "/api/position/recruitment/archive-candidates-by-position/" +
            JPAId +
            "/search/candidates";
        }
      }, 450);
    }
    setTimeout(() => {
      let Req = {
        method: "POST",
        baseURL: RequestURL,
        headers: {
          Authorization: "Bearer " + window.localStorage.getItem("Token"),
          "Content-Type": "application/json",
        },
        data: Data,
      };
      axios(Req)
        .then((Res) => {
          console.log(Res);
          setDeletedCandidates(Res.data.results);
          setTotalElements(Res.data.totalElements);
          if (
            document.getElementById("end") !== null &&
            Res.data.totalElements < SelectedSize
          ) {
            document.getElementById("end").innerHTML = Res.data.totalElements;
          } else if (document.getElementById("end") !== null) {
            document.getElementById("end").innerHTML = Start + Size;
          }
          if (Res.data.results.length === 0) {
            document.getElementById("info-footer").style.display = "none";
          } else {
            if (window.innerWidth > 450) {
              document.getElementById("info-footer").style.display = "flex";
            } else {
              document.getElementById("info-footer").style.display = "grid";
            }
          }
          if (IsInitialLoad && Res.data.results.length === 0) {
            setNoCandidates(true);
          }

          if (
            Object.keys(Data.criteria).length === 0 &&
            !IsInitialLoad &&
            Res.data.results.length === 0
          ) {
            setNoCandidates(true);
          }
          setIsLoading(false);
          fetchStatuses();
          fetchLocationsByJPAId();
          if (Res.data.results.length > 0) {
            createPagination(Res.data.totalElements);
          }
        })
        .catch((Err) => {
          console.log(Err);
        });
    }, 470);
  };

  const fetchStatuses = () => {
    let JPAId = window.localStorage.getItem("JPAItemId");

    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/recruitment/candidates-by-position/" +
        JPAId +
        "/search/status",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        var AvailableStatuses = [];

        Res.data.map((Item) => {
          if (Item === "ACCEPTED") {
            AvailableStatuses.push({ name: "Accepted", id: "ACCEPTED" });
          } else if (Item === "NOT_ACCEPTED") {
            AvailableStatuses.push({
              name: "Not Accepted",
              id: "NOT_ACCEPTED",
            });
          } else if (Item === "APPLIED") {
            AvailableStatuses.push({ name: "Applied", id: "APPLIED" });
          } else if (Item === "REVIEW") {
            AvailableStatuses.push({ name: "Review", id: "REVIEW" });
          } else if (Item === "INTERVIEW") {
            AvailableStatuses.push({ name: "Interview", id: "INTERVIEW" });
          } else if (Item === "FINAL_DECISION") {
            AvailableStatuses.push({ name: "Decision", id: "FINAL_DECISION" });
          } else if (Item === "CANCELLED") {
            AvailableStatuses.push({ name: "Cancelled", id: "CANCELLED" });
          }
        });
        setStatuses(AvailableStatuses);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchCandidates = (IsInitialLoad, Start, Size, InitialSearchValue) => {
    let JPAId = window.localStorage.getItem("JPAItemId");

    let Data = {
      criteria: {},
      start: Start,
      size: Size,
    };

    //nameLike filter
    if (InitialSearchValue && IsInitialLoad) {
      // adding the initial search name value only when redirected from a notification
      Data.criteria.nameLike = InitialSearchValue;
      document.getElementById("search-input").value = InitialSearchValue;
      document.getElementById("search-placeholder").style.display = "none";
      document.getElementById("clear-btn").classList.remove("hidden");
    } else if (document.getElementById("search-input").value.length > 0) {
      Data.criteria.nameLike = document.getElementById("search-input").value;
    }

    //status filter
    let SelectedStatuses = [];
    Statuses.map((Status) => {
      if (
        document
          .getElementById("icon-" + Status.id)
          .classList.contains("feather-check-selected")
      ) {
        SelectedStatuses.push(Status.id);
      }
    });
    if (SelectedStatuses.length > 0) {
      Data.criteria.applicationStatus = SelectedStatuses;
    }

    //location filter
    let SelectedLocations = [];
    Locations.map((Item) => {
      if (
        document
          .getElementById("icon-" + Item.id)
          .classList.contains("feather-check-selected")
      ) {
        SelectedLocations.push(Item.name);
      }
    });
    if (SelectedLocations.length > 0) {
      Data.criteria.workCities = SelectedLocations;
    }

    //identity filter
    let SelectedIdentities = [];
    IdentityFilterOptions.map((Item) => {
      if (
        document
          .getElementById("icon-" + Item.id)
          .classList.contains("feather-check-selected")
      ) {
        if (Item.id === "ANONYMOUS") {
          SelectedIdentities.push(false);
        } else {
          SelectedIdentities.push(true);
        }
      }
    });
    if (SelectedIdentities.length > 0) {
      Data.criteria.applicationType = SelectedIdentities;
    }

    var RequestURL;
    if (IsInitialLoad) {
      RequestURL =
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/recruitment/candidates-by-position/" +
        JPAId +
        "/search/candidates";
    } else {
      // defining request url based on either saved items are requested or all items (saved items only switch button)
      setTimeout(() => {
        if (
          document.getElementById("saved-switch-holder").classList.length === 1
        ) {
          RequestURL =
            window._env_.API_URL +
            Config.PositionServiceURL +
            "/api/position/recruitment/candidates-by-position/" +
            JPAId +
            "/search/bookmark";
        } else {
          RequestURL =
            window._env_.API_URL +
            Config.PositionServiceURL +
            "/api/position/recruitment/candidates-by-position/" +
            JPAId +
            "/search/candidates";
        }
      }, 450);
    }

    setTimeout(() => {
      let Req = {
        method: "POST",
        baseURL: RequestURL,
        headers: {
          Authorization: "Bearer " + window.localStorage.getItem("Token"),
          "Content-Type": "application/json",
        },
        data: Data,
      };
      axios(Req)
        .then((Res) => {
          console.log(Res);
          setCandidates(Res.data.results);
          setTotalElements(Res.data.totalElements);
          setTimeout(() => {
            if (
              document.getElementById("end") !== null &&
              Res.data.totalElements < SelectedSize
            ) {
              document.getElementById("end").innerHTML = Res.data.totalElements;
            } else if (document.getElementById("end") !== null) {
              document.getElementById("end").innerHTML = Start + Size;
            }
          }, 50);
          if (Res.data.results.length === 0) {
            document.getElementById("info-footer").style.display = "none";
          } else {
            if (window.innerWidth > 450) {
              document.getElementById("info-footer").style.display = "flex";
            } else {
              document.getElementById("info-footer").style.display = "grid";
            }
          }
          if (IsInitialLoad && Res.data.results.length === 0) {
            setNoCandidates(true);
          } else {
            setNoCandidates(false);
          }

          if (
            Object.keys(Data.criteria).length === 0 &&
            !IsInitialLoad &&
            Res.data.results.length === 0
          ) {
            setNoCandidates(true);
          }
          setIsLoading(false);
          fetchStatuses();
          fetchLocationsByJPAId();
          if (Res.data.results.length > 0) {
            createPagination(Res.data.totalElements);
          }

          // When a tab is clicked or the first page is requested and it is not
          // the initial load, this function will check again for the status of
          // JPA to remove the disabled state from all application cards.
          if (Start === 0 && !IsInitialLoad) {
            checkAcceptanceStatus();
          }
        })
        .catch((Err) => {
          console.log(Err);
        });
    }, 500);
  };

  const createPagination = (TotalCount) => {
    let Size = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    let Count = Math.ceil(TotalCount / Size);
    let PagesArray = [];
    for (let i = 0; i < Count; i++) {
      PagesArray.push(i + 1);
    }
    setPages(PagesArray);
    shortenPagination(PagesArray);
  };

  const shortenPagination = (Pages) => {
    if (Pages.length > 0) {
      let LastPage = Pages.reduce((a, b) => {
        return Math.max(a, b);
      });
      let FirstPage = parseInt(Pages[0]);
      let MiddlePage = 3;
      let FirstDotsShown = false;
      let LastDotsShown = true;
      let ActivePage;

      for (let i = 1; i <= Pages.length; i++) {
        if (document.getElementById(i + "-page-btn") !== null) {
          if (
            document
              .getElementById(i + "-page-btn")
              .classList.contains("active-page")
          ) {
            ActivePage = i;
          }
        }
      }
      if (ActivePage < 3) {
        LastDotsShown = true;
      }
      if (ActivePage > 3) {
        FirstDotsShown = true;
        MiddlePage = ActivePage;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      if (ActivePage < MiddlePage && ActivePage > 3) {
        FirstDotsShown = true;
        LastDotsShown = true;
      }
      if (parseInt(LastPage - 3) >= ActivePage) {
        LastDotsShown = false;
      }
      if (ActivePage === 3) {
        FirstDotsShown = false;
        MiddlePage = 3;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      setPageInfo({
        FirstPage: FirstPage,
        FirstDotsShown: FirstDotsShown,
        MiddlePage: MiddlePage,
        LastDotsShown: LastDotsShown,
        LastPage: LastPage,
        ActivePage: ActivePage,
      });
    } else {
      setPageInfo({
        FirstPage: 1,
        FirstDotsShown: false,
        MiddlePage: 3,
        LastDotsShown: true,
        LastPage: 1,
        ActivePage: 1,
      });
    }
  };
  const updatePaginationlength = (PageNum) => {
    shortenPagination(Pages);
    if (PageNum === PageInfo.LastPage) {
      document.getElementById("next-page").classList.add("page-btn-disabled");
    } else {
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
    }
  };

  const updateActiveClass = (PageNumber) => {
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        document
          .getElementById(i + "-page-btn")
          .classList.remove("active-page");
      }
    }
    document
      .getElementById(PageNumber + "-page-btn")
      .classList.add("active-page");
  };
  const requestNextPage = () => {
    let NextPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          NextPage = parseInt(i + 1);
        }
      }
    }
    if (document.getElementById(NextPage + "-page-btn") !== null) {
      document.getElementById(NextPage + "-page-btn").click();
    }
  };
  const requestPrevPage = () => {
    let PrevPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          if (i === 1) {
            PrevPage = 1;
          } else {
            PrevPage = parseInt(i - 1);
          }
        }
      }
    }
    if (document.getElementById(PrevPage + "-page-btn") !== null) {
      document.getElementById(PrevPage + "-page-btn").click();
    }
  };

  const requestPageNumber = (PageNumber) => {
    let Size = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    let NewStart = parseInt((PageNumber - 1) * Size);
    if (document.getElementById("active").classList.contains("active-tab")) {
      fetchCandidates(false, NewStart, Size);
    } else {
      fetchDeletedCandidates(false, NewStart, Size);
    }

    if (NewStart === 0) {
      document.getElementById("start").innerHTML = 1;
    } else {
      document.getElementById("start").innerHTML = NewStart + 1;
    }
    if (parseInt(document.getElementById("end").innerHTML) === TotalElements) {
      document.getElementById("next-page").classList.add("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    } else {
      document.getElementById("end").innerHTML = parseInt(NewStart + Size);
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    }
    if (PageNumber === 1) {
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    }
    updateActiveClass(PageNumber);
    updatePaginationlength(PageNumber);
  };
  const setSize = () => {
    let SelectedSize = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    setSelectedSize(SelectedSize);
    setTimeout(() => {
      if (document.getElementById("1-page-btn") !== null) {
        document.getElementById("1-page-btn").click();
      }
    }, 300);
  };

  const fetchLocationsByJPAId = () => {
    let JPAId = window.localStorage.getItem("JPAItemId");
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/recruitment/candidates-by-position/" +
        JPAId +
        "/search/work-cities",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let Locations = [];
        Res.data.map((Loc) => {
          Locations.push({
            name: Loc,
            id: Loc.toLowerCase()
              .replace(" ", "_")
              .replace(" ", "_")
              .replace(" ", "_")
              .replace(" ", "_"),
          });
        });
        setLocations(Locations);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const refreshPageData = () => {
    resetFilters();
    fetchJPADetails();
    checkDeletedCandidatesLength();
    if (document.getElementById("active").classList.contains("active-tab")) {
      fetchDeletedCandidates(false, 0, SelectedSize);
    } else {
      fetchCandidates(false, 0, SelectedSize);
    }
  };

  const resetFilters = () => {
    if (document.getElementById("clear-btn") !== null) {
      document.getElementById("clear-btn").click();
    }
    if (document.getElementById("status-clear") !== null) {
      document.getElementById("status-clear").click();
    }
    if (document.getElementById("location-clear") !== null) {
      document.getElementById("location-clear").click();
    }
    if (document.getElementById("identity-clear") !== null) {
      document.getElementById("identity-clear").click();
    }

    if (document.getElementById("saved-switch-holder").classList.length === 1) {
      document.getElementById("saved-switch-holder").click();
    }
  };

  const goBack = () => {
    document.getElementById("back-link").click();
  };

  //Is only called in ./Head.js for fetching and updating the page data based on selected filters
  const toggleFetchCandidates = () => {
    if (document.getElementById("active").classList.contains("active-tab")) {
      fetchCandidates(false, 0, SelectedSize);
    } else {
      fetchDeletedCandidates(false, 0, SelectedSize);
    }
    setTimeout(() => {
      if (Candidates.length > 0) {
        document.getElementById("1-page-btn").click();
      }
    }, 300);
  };

  const toggleDeleted = () => {
    fetchDeletedCandidates(true, 0, 6);
    fetchJPADetails();
  };
  const toggleActive = () => {
    fetchCandidates(true, 0, 6);
    fetchJPADetails();
  };

  const toggleExport = () => {
    let JPAId = window.localStorage.getItem("JPAItemId");
    let Data = {
      criteria: {},
    };
    //nameLike filter
    if (document.getElementById("search-input").value.length > 0) {
      Data.criteria.nameLike = document.getElementById("search-input").value;
    }

    //status filter
    let SelectedStatuses = [];
    Statuses.map((Status) => {
      if (
        document
          .getElementById("icon-" + Status.id)
          .classList.contains("feather-check-selected")
      ) {
        SelectedStatuses.push(Status.id);
      }
    });
    if (SelectedStatuses.length > 0) {
      Data.criteria.applicationStatus = SelectedStatuses;
    }

    //location filter
    let SelectedLocations = [];
    Locations.map((Item) => {
      if (
        document
          .getElementById("icon-" + Item.id)
          .classList.contains("feather-check-selected")
      ) {
        SelectedLocations.push(Item.name);
      }
    });
    if (SelectedLocations.length > 0) {
      Data.criteria.workCities = SelectedLocations;
    }

    //identity filter
    let SelectedIdentities = [];
    IdentityFilterOptions.map((Item) => {
      if (
        document
          .getElementById("icon-" + Item.id)
          .classList.contains("feather-check-selected")
      ) {
        if (Item.id === "ANONYMOUS") {
          SelectedIdentities.push(false);
        } else {
          SelectedIdentities.push(true);
        }
      }
    });
    if (SelectedIdentities.length > 0) {
      Data.criteria.applicationType = SelectedIdentities;
    }
    let CriteriaLength = Object.keys(Data.criteria).length;
    if (CriteriaLength === 0) {
      exportWithoutFilters(JPAId);
    } else {
      exportWithFilters(JPAId, Data);
    }
  };
  const exportWithFilters = (JPAId, FilterData) => {
    let Req = {
      method: "POST",
      responseType: "blob",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/recruitment/candidates-by-position/" +
        JPAId +
        "/export-data-with-filter",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: FilterData,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let URL = window.URL.createObjectURL(new Blob([Res.data]));
        let Link = document.createElement("a");
        Link.href = URL;
        Link.setAttribute("download", "export_candidate_list.xlsx");
        document.body.appendChild(Link);
        Link.click();
        setTimeout(() => {
          document.body.removeChild(Link);
        }, 500);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const exportWithoutFilters = (JPAId) => {
    let Req = {
      method: "GET",
      responseType: "blob",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/recruitment/candidates-by-position/" +
        JPAId +
        "/export-data-no-filter",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let URL = window.URL.createObjectURL(new Blob([Res.data]));
        let Link = document.createElement("a");
        Link.href = URL;
        Link.setAttribute("download", "export_candidate_list.xlsx");
        document.body.appendChild(Link);
        Link.click();
        setTimeout(() => {
          document.body.removeChild(Link);
        }, 500);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  return (
    <div className="main-content vacancies-wrapper jpa-details">
      <NavLink id="back-link" to={"/vacancies"}></NavLink>
      <ImagePreloader Images={[BookmarkPlus, BookmarkedIcon]} />
      <Header LangData={props.LangData} PageName={translateText("vacancies")} />
      <div className="content-header">
        <div className="address">
          <p>{translateText("jobs")}</p>
          <img src={Circle} alt="." />
          <p>{translateText("vacancies")}</p>
          <img src={Circle} alt="." />
          <p>{translateText("candidates")}</p>
        </div>
      </div>
      {ItemDetails === undefined ? (
        <div className="jpa-details-head"></div>
      ) : (
        <Head
          Details={ItemDetails}
          LangData={props.LangData}
          IsJob
          Locations={Locations}
          ToggleFetchCandidates={() => toggleFetchCandidates()}
          StatusOptions={Statuses}
          IdentityFilterOptions={IdentityFilterOptions}
          ShowDeleted={() => toggleDeleted()}
          ShowActive={() => toggleActive()}
          ToggleExport={() => toggleExport()}
        />
      )}
      {IsLoading ? (
        <div className="empty-candidates-wrapper">
          <div className="candidates-wrapper">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <CandidateSkeleton key={i} />
            ))}
          </div>
        </div>
      ) : (
        <div className="empty-candidates-wrapper">
          {Candidates.length === 0 ? (
            <React.Fragment>
              {NoCandidates ? (
                <div id="active-candidates">
                  <EmptyState
                    StateName={"candidate"}
                    ResetFilters={() => resetFilters()}
                    Message={translateText("candidates_empty_state")}
                    LangData={props.LangData}
                    ActionButton={
                      <button
                        className="action-back-btn"
                        onClick={() => goBack()}
                      >
                        <i className="feather-arrow-left"></i>
                        {translateText("back")}
                      </button>
                    }
                  />
                </div>
              ) : (
                <div id="active-candidates">
                  <EmptyState
                    StateName={"candidate"}
                    ResetFilters={() => resetFilters()}
                    LangData={props.LangData}
                  />
                </div>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className="candidates-wrapper" id="active-candidates">
                {Candidates.map((Candidate) => (
                  <CandidateItem
                    Data={Candidate}
                    IsAnonymous={
                      Candidate.candidate.revealIdentity ? false : true
                    }
                    Status={Candidate.application.status}
                    RefreshData={() => refreshPageData()}
                    IsAccepted={IsAccepted}
                    DisableItems={() => setIsAccepted(true)}
                    UserInfo={props.UserInfo}
                    LangData={props.LangData}
                    IsJob
                    JPA={ItemDetails}
                    FetchCandidates={() => fetchCandidates()}
                  />
                ))}
              </div>
            </React.Fragment>
          )}
          <React.Fragment>
            {DeletedCandidates.length === 0 ? (
              <div className="candidates-wrapper" id="deleted-candidates">
                <EmptyState
                  StateName={"candidate"}
                  ResetFilters={() => null}
                  Message={translateText("no_deleted_candidates_info_text")}
                  LangData={props.LangData}
                  ActionButton={<span hidden></span>}
                />
              </div>
            ) : (
              <div className="candidates-wrapper" id="deleted-candidates">
                {DeletedCandidates.map((Candidate) => (
                  <CandidateItem
                    Data={Candidate}
                    IsAnonymous={
                      Candidate.candidate.revealIdentity ? false : true
                    }
                    Status={Candidate.application.status}
                    RefreshData={() => refreshPageData()}
                    IsAccepted={IsAccepted}
                    DisableItems={() => setIsAccepted(true)}
                    UserInfo={props.UserInfo}
                    LangData={props.LangData}
                    IsDeleted={true}
                    IsJob
                    JPA={ItemDetails}
                    FetchCandidates={() => fetchCandidates()}
                  />
                ))}
              </div>
            )}
          </React.Fragment>
        </div>
      )}
      <React.Fragment>
        {!NoCandidates ||
        Candidates.length > 0 ||
        (NoCandidates && DeletedCandidates.length > 0) ? (
          <div className="info-footer jpa-details-footer" id="info-footer">
            <div className="pagenumber-summary">
              {translateText("showing")} <p id="start">1</p>
              {translateText("to")} <p id="end">6</p>
              {translateText("of")} {TotalElements} {translateText("items")}.
            </div>
            <section className="pagination-holder">
              <button
                onClick={() => requestPrevPage()}
                id="prev-page"
                className={
                  Pages.length < 6
                    ? "page-btn page-btn-disabled right-margined"
                    : "page-btn page-btn-disabled"
                }
              >
                <i className="feather-chevron-left"></i>
              </button>
              <React.Fragment>
                {Pages.length < 6 ? (
                  <React.Fragment>
                    {Pages.map((Page) => (
                      <React.Fragment>
                        {Page === 1 ? (
                          <button
                            key={Page}
                            onClick={() => requestPageNumber(Page)}
                            className="page-btn active-page"
                            id={Page + "-page-btn"}
                          >
                            {Page}
                          </button>
                        ) : (
                          <button
                            key={Page}
                            onClick={() => requestPageNumber(Page)}
                            className="page-btn"
                            id={Page + "-page-btn"}
                          >
                            {Page}
                          </button>
                        )}
                      </React.Fragment>
                    ))}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <button
                      onClick={() => requestPageNumber(1)}
                      className="page-btn active-page"
                      id={1 + "-page-btn"}
                    >
                      {1}
                    </button>
                    {PageInfo.FirstDotsShown ? <p>...</p> : null}
                    <button
                      onClick={() =>
                        requestPageNumber(parseInt(PageInfo.MiddlePage - 1))
                      }
                      className="page-btn"
                      id={parseInt(PageInfo.MiddlePage - 1) + "-page-btn"}
                    >
                      {parseInt(PageInfo.MiddlePage - 1)}
                    </button>
                    {PageInfo.MiddlePage === PageInfo.LastPage ? null : (
                      <button
                        onClick={() => requestPageNumber(PageInfo.MiddlePage)}
                        className="page-btn"
                        id={PageInfo.MiddlePage + "-page-btn"}
                      >
                        {PageInfo.MiddlePage}
                      </button>
                    )}
                    {parseInt(PageInfo.MiddlePage + 1) >=
                    PageInfo.LastPage ? null : (
                      <button
                        onClick={() =>
                          requestPageNumber(parseInt(PageInfo.MiddlePage + 1))
                        }
                        className="page-btn "
                        id={parseInt(PageInfo.MiddlePage + 1) + "-page-btn"}
                      >
                        {parseInt(PageInfo.MiddlePage + 1)}
                      </button>
                    )}
                    {!PageInfo.LastDotsShown ? <p>...</p> : null}
                    <button
                      onClick={() => requestPageNumber(PageInfo.LastPage)}
                      className="page-btn"
                      id={PageInfo.LastPage + "-page-btn"}
                    >
                      {PageInfo.LastPage}
                    </button>
                  </React.Fragment>
                )}
              </React.Fragment>
              <button
                onClick={() => requestNextPage()}
                id="next-page"
                className={
                  Pages.length < 6 ? "page-btn left-margined" : "page-btn"
                }
              >
                <i className="feather-chevron-right"></i>
              </button>
            </section>
            <div className="row-count-select">
              <p className="row-info">{translateText("rows_per_page")}</p>
              <Select
                Initial={"6"}
                Options={SizeOptions}
                IsWithId
                Id={"row-per-page"}
                ChangeHandler={() =>
                  setTimeout(() => {
                    setSize();
                  }, 100)
                }
                ValidationError=""
              />
            </div>
          </div>
        ) : null}
      </React.Fragment>
    </div>
  );
};

export default JobDetails;
